import React, { useContext, useRef, useState } from "react";
import "./WebDevelopment.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";
import animation from "../../../../../Animation/Web.json";

import { Menu } from "../../../../../Context/MenuOpen/MenuContext";
import Lottie from "react-lottie";
const WebDevelopment = () => {
  const {t , i18n} = useTranslation()
  const lottieContainerRef = useRef(null);
  const menu = useContext(Menu);
  const isOpen = menu.isOpen;
  const [playLottie, setPlayLottie] = useState(false);
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  gsap.registerPlugin(ScrollTrigger);
  useGSAP(() => {
  
    ScrollTrigger.create({
      trigger: lottieContainerRef.current,
      start: "top 80%",
      toggleActions: "play reverse play reverse",
      onEnter: () => setPlayLottie(true),
    });
  });
  return (
    <div className="WebDevelopment">
      <div className="svg">
        <div className="flex flex-col items-start">
          <h4>{t("BESPOKE SOLUTION")}</h4>
          <h5>{t("Web Development")}</h5>
          <div ref={lottieContainerRef} className="w-[80vw] md:w-[35vw] mt-[5vh]">
          {playLottie || isOpen ? (
          <Lottie
            options={defaultOptions}
            className="custom-lottie"
            isClickToPauseDisabled={true}
          />
        ) : (
          ""
        )}
          </div>
        </div>
      </div>
      <div className="content">
        <p>
          {t("We build digital spaces that are designed to grow with you. Whether you need a sleek website or a fully customized platform, we focus on performance, clarity, and alignment with your brand. Every detail from UX flow to backend structure is built to work fast, feel smooth, and scale easily. Our team brings both design and tech expertise to deliver websites and mobile apps that aren’t just functional, but purposeful.")}
        </p>
        <ul>
          <li>
          {t("We create and develop websites that are visually engaging, fully responsive, and tailored to your goals.")}

          </li>
          <li>
          {t("We manage your website post-launch handling content updates, technical tweaks, and performance monitoring.")}
          </li>
          <li>
          {t("Our hosting services ensure your site is secure, stable, and always accessible to your audience.")}
          </li>
          <li>
          {t("We develop custom mobile applications with seamless UX across iOS and Android, built to match your platform’s logic and user needs.")}
          </li>
          <li>
        {t("All our builds are optimized for speed, SEO, and long-term usability from landing pages to full platforms.")}
          </li>
        </ul>
        <Link className="btn-hover" to="/web-solution">
          <span>{t("Web Development")}</span>
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 32 32"
            >
              <path
                fill="currentColor"
                d="M8 4v4H4V4zM2 2v8h8V2zm16 5v4h-4V7zm-6-2v8h8V5zM8 16v4H4v-4zm-6-2v8h8v-8z"
              />
              <path
                fill="currentColor"
                d="M22 10v6h-6v6h-6v8h20V10Zm-4 8h4v4h-4Zm-2 10h-4v-4h4Zm6 0h-4v-4h4Zm6 0h-4v-4h4Zm0-6h-4v-4h4Zm-4-6v-4h4v4Z"
              />
            </svg>
          </span>
        </Link>
      </div>
    </div>
  );
};

export default WebDevelopment;
